import React from 'react'
import PropTypes from 'prop-types'
import { Card } from 'transfix-ui/components/Card'
import { ExpandableText } from 'transfix-ui/components/ExpandableText'
import { ComplianceRequirements } from './ComplianceRequirements'
import { LoadDetailsRow } from './LoadDetailsRow'

export const LoadDetailsCard = React.memo(
  ({ carrierSpecialInstructions, shipperInsuranceRequirement, stops }) => (
    <Card title='Load Details' collapsible transparent mini>
      {stops &&
        stops.map((stop, i) => {
          const nextStopMiles = stops[i + 1] ? stops[i + 1].facility.miles : ''
          return <LoadDetailsRow key={stop.id} stop={stop} nextStopMiles={nextStopMiles} />
        })}
      <ComplianceRequirements requirements={shipperInsuranceRequirement} />
      {carrierSpecialInstructions && (
        <ExpandableText text={carrierSpecialInstructions} label='Carrier Instructions' />
      )}
    </Card>
  )
)

LoadDetailsCard.propTypes = {
  stops: PropTypes.arrayOf(PropTypes.shape({})),
  carrierSpecialInstructions: PropTypes.string,
  shipperInsuranceRequirement: PropTypes.arrayOf(PropTypes.string),
}

LoadDetailsCard.defaultProps = {
  stops: [{}],
  carrierSpecialInstructions: '',
  shipperInsuranceRequirement: [],
}
